export enum LearningCoursesTypes {
  GET_LEARNING_COURSES_ONCE = '@learningCourses/GET_LEARNING_COURSES_ONCE',

  FETCH_COURSES_REQUEST = '@learningCourses/FETCH_COURSES_REQUEST',
  FETCH_COURSES_FAILURE = '@learningCourses/FETCH_COURSES_FAILURE',
  FETCH_COURSES_SUCCESS = '@learningCourses/FETCH_COURSES_SUCCESS',

  CLEAR_COURSES = '@learningCourses/CLEAR_COURSES',
}

export interface LearningCourses {
  active: boolean
  completePackage: boolean
  contentType: string
  finalDate: string | null
  courseId: string
  createdAt: string
  explanationPdfUrl: string
  features: {
    infiniteGuarantee: boolean
    satisfactionGuarantee: boolean
  }
  icon: string
  image: string
  items: {
    active: boolean
    name: string
    _id: string
  }
  modules: number
  name: string
  notice: string
  number: number
  orderId: string
  permanentLink: string
  progress: number
  total: {
    video: {
      amount: number
    }
    excerto: {
      amount: number
    }
  }
  type: string
  _id: string
}

export interface LearningCoursesState {
  data: LearningCourses[]
  error: boolean
  status: 'idle' | 'loading' | 'success' | 'error'
}
